export default __webpack_public_path__ + "navigation-examples-custom-banner-v1-960-d635736b75eb06bb3d346bbf3598a2f2.png";